"use strict";

(function() {

	let hostname = window.location.hostname;
	let documentclasslist = document.documentElement.classList;

	// indicate if server is testserver, or not our own server (eg Google Translate)
	if (hostname.match(/test/)) {
		documentclasslist.add("test");
	} else if (hostname.match(/local/)) {
		documentclasslist.add("local");
	} else if (hostname.match(/prod/)) {
		documentclasslist.add("prod");
	} else if (hostname.match(/husbanken\.no$/)) { // NB: allow https://husbanken.no/
		documentclasslist.add("live");
	} else {
		documentclasslist.add("copy");
	}

})();
